'use client';

import { useEffect, useState } from 'react';
import config from '@/config/config';

/**
 * Dynamically updates PWA-related meta tags based on db settings
 * This runs client-side to update the tags added in layout.js
 */
export default function PwaMetaTags() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded) return;

    const updateMetaTags = async () => {
      try {
        const res = await fetch(`${config.NEXT_PUBLIC_API_URL}/api/public/pwa/manifest`);
        const data = await res.json();
        if (!data.success || !data.data) return;

        const manifest = data.data;

        // Update theme-color meta tag
        if (manifest.theme_color) {
          updateMeta('theme-color', manifest.theme_color);
        }

        // Update apple-mobile-web-app-title
        if (manifest.name) {
          updateMeta('apple-mobile-web-app-title', manifest.name);
          updateMeta('application-name', manifest.name);
        }

        // Add apple-touch-icon if provided
        const appleIcon = manifest.icons?.find(i => i.sizes === '180x180') || manifest.icons?.find(i => i.sizes === '192x192');
        if (appleIcon) {
          let link = document.querySelector('link[rel="apple-touch-icon"]');
          if (!link) {
            link = document.createElement('link');
            link.rel = 'apple-touch-icon';
            document.head.appendChild(link);
          }
          link.href = appleIcon.src;
        }

        setLoaded(true);
      } catch {
        // Silently fail
      }
    };

    updateMetaTags();
  }, [loaded]);

  return null;
}

function updateMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (meta) {
    meta.content = content;
  } else {
    meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  }
}
